module.exports = __webpack_public_path__ + "../resources/img/ic_history_default.91ddc641.svg";